export default __webpack_public_path__ + "static/media/Hexagon170.38815801.svg";